import { create } from "zustand";
import { toast } from "react-toastify";

export type ResumePayload = {
  resumeFile?: File | null;
  website?: string;
};

type ResumeState = {
  loading: boolean;
  updateResume: (data: ResumePayload) => Promise<boolean>;
};

const getAccessToken = (): string | null => {
  if (typeof window === "undefined") return null;

  try {
    const raw = localStorage.getItem("auth-storage");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.state?.accessToken || null;
  } catch {
    return null;
  }
};

export const useResumeStore = create<ResumeState>((set) => ({
  loading: false,

  updateResume: async (data) => {
    try {
      set({ loading: true });

      const token = getAccessToken();
      if (!token) throw new Error("No token");

      const formData = new FormData();

      if (data.resumeFile) {
        if (data.resumeFile.size > 2 * 1024 * 1024) {
          toast.error("Resume file max 2 MB");
          return false;
        }
        formData.append("resume", data.resumeFile);
      }

      if (data.website) {
        formData.append("website", data.website);
      }

      const res = await fetch(
        "https://admin-talentlink.digiline.id/api/candidate/resume",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            // ❌ jangan set Content-Type untuk FormData
          },
          body: formData,
        }
      );

      if (!res.ok) throw new Error("Upload resume failed");

      toast.success("Resume updated successfully");
      return true;
    } catch (err) {
      console.error(err);
      toast.error("Failed to update resume");
      return false;
    } finally {
      set({ loading: false });
    }
  },
}));
